export default {
  name: 'exproess-detail2',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};